import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {

  private theme = new BehaviorSubject<any>('light');
  theme$ = this.theme.asObservable();

  private activeBackground = new BehaviorSubject<number[]>([0, 0, 0]);
  activeBackground$ = this.activeBackground.asObservable();

  constructor(private platformService: PlatformService) {
    // Initialize theme from localStorage only on client side
    if (this.platformService.isClient) {
      const savedTheme = this.platformService.getLocalStorageItem('mode');
      if (savedTheme) {
        this.theme.next(savedTheme);
      }
    }

    const themeStyles: any = {
      dark: {
        '--background': '19, 20, 21',
        '--background-inverse': '255, 255, 255',
        '--background-box': '#2B2C2D',
        '--text-color': '190, 190, 190',
        '--dark-text': '255, 255, 255',
        '--text-contrast': '#888',
        '--contrast': '#383838',
        '--contrast-light': '#2B2C2D',
        '--shadow': '0, 0, 0, .1',
        '--dropdown': '255, 255, 255'
      },
      light: {
        '--background': '255, 255, 255',
        '--background-inverse': '19, 20, 21',
        '--background-box': '#E7E7E7',
        '--text-color': '0, 0, 0',
        '--dark-text': '0, 0, 0',
        '--text-contrast': '#666',
        '--contrast': '#D1D1D2',
        '--contrast-light': '#E7E7E7',
        '--shadow': '0, 0, 0, .05',
        '--dropdown': '0, 0, 0'
      }
    }

    this.theme$.subscribe((res: any) => {
      this.setThemeStyles(res, themeStyles[res]);
    });
  }

  setThemeStyles(theme: string, themeStyles: any) {
    Object.keys(themeStyles).map((property) => {
      this.platformService.setDocumentElementStyle(
        property,
        themeStyles[property]
      );
    });
    this.platformService.setBodyDataAttribute('theme', theme);
  }

  setTheme(value: string, temporary?: boolean) {
    this.theme.next(value);
    if (!temporary) this.platformService.setLocalStorageItem('mode', value);
  }

  async setBackgroundColor($event: tinycolor.ColorFormats.RGBA) {
    this.activeBackground.next([$event.r, $event.g, $event.b]);
  }

}
